export function cvadCostCalculationFunction(edition, users) {
  if (edition === 'PAYGO') {
    return {
      cvadCostperUserperYearValue: 10 * 12,
      totalCost: 10 * users * 12,
    };
  } else {
    var totalCost = 0;
    const tier = [];
    var tempUsers = users;
    while (tempUsers) {
      if (tempUsers > 100 && tier.length == 0) {
        tier.push(100);
        tempUsers = tempUsers - 100;
      }
      if (tempUsers > 149 && tier.length == 1) {
        tier.push(149);
        tempUsers = tempUsers - 149;
      }
      if (tempUsers > 749 && tier.length == 2) {
        tier.push(749);
        tempUsers = tempUsers - 749;
      }
      if (tempUsers > 1499 && tier.length == 3) {
        tier.push(1499);
        tempUsers = tempUsers - 1499;
      }
      if (tempUsers > 2001 && tier.length == 4) {
        tier.push(2001);
        tempUsers = tempUsers - 2001;
      } else {
        tier.push(tempUsers);
        tempUsers = 0;
      }
    }

    tier.forEach((item, index) => {
      if (index == 0) {
        totalCost += item * 160;
      }
      if (index == 1) {
        totalCost += item * 130;
      }

      if (index == 2) {
        totalCost += item * 105;
      }

      if (index == 3) {
        totalCost += item * 90;
      }
      if (index == 4) {
        totalCost += item * 70;
      }
      if (index == 5) {
        totalCost += item * 55;
      }
    });
    //returning peruser per year value
    const cvadCostperUserperYearValue = totalCost / users;
    return {
      cvadCostperUserperYearValue: 10 * 12,
      totalCost: 10 * users * 12,
    };
  }
}
